import { combineReducers } from 'redux';

import filterLists from "./findActivities/filters";
import searchActivities from "./findActivities/search";
import selectedFilters from "./findActivities/selectedFilters";
import searchValues from "./findActivities/searchValues";
import displayType from "./findActivities/displayType";

const crmApp = combineReducers({
    filterLists,
    searchActivities,
    selectedFilters,
    searchValues,
    displayType,
});

export default crmApp;
